/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_First_Meeting_Preview_TitleInputs */



/**
* | output |
* | --- |
* | "In Wundo" |
*
* @param {Onboarding_First_Meeting_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_first_meeting_preview_title = /** @type {((inputs?: Onboarding_First_Meeting_Preview_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_First_Meeting_Preview_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("In Wundo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dans Wundo")
	return /** @type {LocalizedString} */ ("In Wundo")
});